/**
 * On sidebar link click, scroll content pane into view
 */
(function () {
    'use strict';

    function init() {
        window.addEventListener('click', (event) => {
            const target = event.target;
            if (!(target instanceof Element)) {
                return;
            }

            if (!target.closest('#storeFAQ-page-body')) {
                return;
            }

            const contentPane = document.querySelector('#storeFAQ-page-body .sf-content');
            if (!contentPane) {
                return;
            }

            if (target.closest('.sidebar__link')) {
                contentPane.scrollIntoView({
                    block: 'start',
                    behavior: 'smooth'
                });
                return;
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
